export default __webpack_public_path__ + "static/media/General's Chestguard of the Shining Sun.3eb69216.jpg";